import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import { Box, Typography, useTheme } from '@mui/material';
import Image from '@components/Image';
import { useStyles } from './styles';

const LaptopBlock: FC = () => {
  const { t } = useLocales();
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Box width="100%" sx={styles.container} id="about">
      <Box sx={styles.box}>
        <Typography variant="h2" sx={styles.whiteText}>
          {t('landing.about_alt1')}
        </Typography>
        <Typography variant="h6" sx={styles.text}>
          {t('landing.topblock_text')}
        </Typography>
      </Box>
      <Image alt="cover" src="/mackbook.png" sx={styles.image} />
    </Box>
  );
};

export default LaptopBlock;
